/* GoodsIn statuses */
export const GOODSIN_CREATED = "created";
export const GOODSIN_REQUESTED = "requested";
export const GOODSIN_CONFIRMED = "confirmed";
export const GOODSIN_RECEIVED = "received";
export const GOODSIN_PROCESSING = "processing";
export const GOODSIN_COMPLETED = "completed";
export const GOODSIN_CANCELLED = "cancelled";
